import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const IngresosBodegaApi = () => {
    const [cargando, setCargando] = useState(false);

    const getPaletizaciones = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("prod_bodega_ingresos", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getMetricasEstado = async (params) => {
        try {
            setCargando(true);

            const response = await api.get(
                "prod_bodega_ingresos/metricas_estado",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPaletizaciones,
        getMetricasEstado,
        
        cargando,
    };
};
